import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حساب درجة الاختبار - حاسبة درجة الامتحان";
const DESCRIPTION =
  "احسب نسبة ودرجة اختبارك بسهولة باستخدام حاسبة الدرجات المتقدمة. احصل على النسبة المئوية والدرجة الحرفية بناءً على عدد النقاط والإجابات الخاطئة.";
const KEYWORDS =
  "حاسبة الدرجات, حساب نسبة الدرجات, حساب درجة الاختبار, حاسبة النسبة المئوية, تقدير الدرجات, حاسبة درجات الاختبار, حاسبة درجات الامتحان, أداة حساب الدرجات";
const OG_URL = "https://do-calculate.com/calculator/ar/test-grade";
function GradeCalculator() {
  const [points, setPoints] = useState("");
  const [wrong, setWrong] = useState("");
  const [correct, setCorrect] = useState("");
  const [percentage, setPercentage] = useState("");
  const [grade, setGrade] = useState("");
  useEffect(() => {
    const pointsValue = parseFloat(points) || 0;
    const wrongValue = parseFloat(wrong) || 0;
    const correctValue = parseFloat(correct) || 0;
    if (pointsValue > 0) {
      if (wrong !== "" && correct === "") {
        const calculatedCorrect = pointsValue - wrongValue;
        setCorrect(calculatedCorrect >= 0 ? calculatedCorrect.toString() : "");
      } else if (correct !== "" && wrong === "") {
        const calculatedWrong = pointsValue - correctValue;
        setWrong(calculatedWrong >= 0 ? calculatedWrong.toString() : "");
      }
      const finalCorrect =
        wrong !== "" ? pointsValue - wrongValue : correctValue;
      if (finalCorrect >= 0 && finalCorrect <= pointsValue) {
        const percentageValue = (finalCorrect / pointsValue) * 100;
        setPercentage(Math.round(percentageValue * 100) / 100);
        let gradeValue = "";
        if (percentageValue >= 90) {
          gradeValue = "A";
        } else if (percentageValue >= 80) {
          gradeValue = "B";
        } else if (percentageValue >= 70) {
          gradeValue = "C";
        } else if (percentageValue >= 60) {
          gradeValue = "D";
        } else {
          gradeValue = "F";
        }
        setGrade(gradeValue);
      } else {
        setCorrect("");
        setPercentage("");
        setGrade("");
      }
    }
  }, [points, wrong, correct]);
  const handlePointsChange = (e) => setPoints(e.target.value);
  const handleWrongChange = (e) => {
    setWrong(e.target.value);
    if (points !== "") {
      setCorrect((parseFloat(points) - parseFloat(e.target.value)).toString());
    }
  };
  const handleCorrectChange = (e) => {
    setCorrect(e.target.value);
    if (points !== "") {
      setWrong((parseFloat(points) - parseFloat(e.target.value)).toString());
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <p>
            هذه الآلة الحاسبة لدرجة الاختبار هي أداة لا غنى عنها إذا كنت تبحث عن
            أداة للمساعدة في تحديد مقياس الدرجات. تُعرف أيضًا باسم حاسبة درجات
            الاختبار أو أداة تقدير المعلم، حيث تتيح لك هذه الأداة العثور بسرعة
            على الدرجة والنسبة المئوية بناءً على عدد النقاط والإجابات الخاطئة
            (أو الصحيحة). علاوة على ذلك، يمكنك تغيير مقياس الدرجات الافتراضي
            وتعيين مقياس خاص بك. هل ما زلت تتساءل عن كيفية حساب درجات
            الاختبارات؟ مرر لأسفل لمعرفة المزيد – أو ببساطة جرب هذه الآلة
            الحاسبة لمقياس الدرجات.
          </p>
           <MobileUnderCalAds />
          <div className="border border-light p-3">
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="pointsInput">
                        النقاط / الأسئلة ❔
                      </label>
                    </b>
                    <input
                      id="pointsInput"
                      type="number"
                      placeholder="عدد النقاط"
                      value={points}
                      onChange={handlePointsChange}
                      className="form-control"
                      style={{ width: "200px" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="wrongInput">
                        الأسئلة الخطأ ❌
                      </label>
                    </b>
                    <input
                      id="wrongInput"
                      type="number"
                      placeholder="عدد الأسئلة الخطأ"
                      value={wrong}
                      onChange={handleWrongChange}
                      className="form-control"
                      style={{ width: "200px" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="correctInput">
                        الأسئلة الصحيحة ✔️
                      </label>
                    </b>
                    <input
                      id="correctInput"
                      type="number"
                      placeholder="عدد الأسئلة الصحيحة"
                      value={correct}
                      onChange={handleCorrectChange}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="percentageInput"
                      >
                        النسبة المئوية %
                      </label>
                    </b>
                    <input
                      id="percentageInput"
                      type="text"
                      placeholder="النسبة المئوية"
                      value={percentage}
                      readOnly
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-2">
                    <b>
                      <label className="form-label ms-2" htmlFor="gradeInput">
                        الدرجة
                      </label>
                    </b>
                    <input
                      id="gradeInput"
                      type="text"
                      placeholder="الدرجة"
                      value={grade}
                      readOnly
                      className="form-control"
                      style={{ width: "200px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية حساب درجة الاختبار
                    </h2>
                  </u>
                  <p>
                    لحساب النسبة المئوية لدرجة الاختبار، كل ما تحتاجه هو قسمة
                    النقاط المكتسبة على إجمالي النقاط الممكنة. بعبارة أخرى، أنت
                    ببساطة تجد نسبة الإجابات الصحيحة:
                  </p>
                  <p>
                    <b>
                      نسبة الدرجة = (عدد الإجابات الصحيحة / إجمالي عدد الأسئلة)
                      × 100
                    </b>
                  </p>
                  <p>
                    بما أن عدد الإجابات الصحيحة + عدد الإجابات الخاطئة = إجمالي
                    عدد الأسئلة، يمكننا كتابة المعادلة كالتالي:
                  </p>
                  <p>
                    <b>
                      نسبة الدرجة = 100 × (إجمالي عدد الأسئلة - عدد الإجابات
                      الخاطئة) / إجمالي عدد الأسئلة
                    </b>
                  </p>
                  <p>
                    بعد ذلك، كل ما عليك فعله هو تحويل النسبة المئوية إلى درجة
                    حرفية. مقياس الدرجات الافتراضي يظهر كما في الجدول أدناه:
                  </p>
                  <table >
                    <thead>
                      <tr>
                        <th >الدرجة الحرفية</th>
                        <th >النسبة المئوية</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>A+</td>
                        <td>97-100</td>
                      </tr>
                      <tr>
                        <td>A</td>
                        <td>93-96</td>
                      </tr>
                      <tr>
                        <td>A-</td>
                        <td>90-92</td>
                      </tr>
                      <tr>
                        <td>B+</td>
                        <td>87-89</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>83-86</td>
                      </tr>
                      <tr>
                        <td>B-</td>
                        <td>80-82</td>
                      </tr>
                      <tr>
                        <td>C+</td>
                        <td>77-79</td>
                      </tr>
                      <tr>
                        <td>C</td>
                        <td>73-76</td>
                      </tr>
                      <tr>
                        <td>C-</td>
                        <td>70-72</td>
                      </tr>
                      <tr>
                        <td>D+</td>
                        <td>67-69</td>
                      </tr>
                      <tr>
                        <td>D</td>
                        <td>63-66</td>
                      </tr>
                      <tr>
                        <td>D-</td>
                        <td>60-62</td>
                      </tr>
                      <tr>
                        <td>F</td>
                        <td>أقل من 60</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    إذا كنت لا تفضل استخدام الدرجات مع العلامات الزائدة أو
                    الناقصة، قد يبدو المقياس كالتالي:
                  </p>
                  <ul>
                    <li>A من 90% إلى 100%</li>
                    <li>B من 80% إلى 89%</li>
                    <li>C من 70% إلى 79%</li>
                    <li>D من 60% إلى 69%</li>
                    <li>F من 59% وأقل – وهي ليست درجة ناجحة</li>
                  </ul>
                  <p>
                    أعلاه، يمكنك العثور على نظام الدرجات القياسي للمدارس
                    والجامعات الأمريكية. ومع ذلك، قد تختلف الدرجات بين المدارس
                    والفصول والمعلمين. تحقق دائمًا مسبقًا من النظام المستخدم في
                    حالتك.
                  </p>
                  <p>
                    أحيانًا لا تكون الحدود للدرجة الناجحة 60%، بل على سبيل
                    المثال، 50% أو 65%. ماذا بعد؟ لقد قمنا بتغطية هذا – يمكنك
                    تغيير النطاقات لكل درجة! اقرأ المزيد عن ذلك في القسم الأخير
                    من هذه المقالة: خيارات الوضع المتقدم.
                  </p>
                  <p>
                    قد تكون مهتمًا أيضًا بحاسبة درجة الفصل الدراسي وحاسبة الدرجة
                    النهائية.
                  </p>
                  <h2 style={{ fontSize: "16px" }}>
                    حاسبة درجة الاختبار – كيفية استخدامها؟
                  </h2>
                  <p>
                    حاسبة درجات الاختبار لدينا هي أداة بسيطة وسهلة الاستخدام!
                  </p>
                  <p>
                    أدخل عدد الأسئلة/النقاط/المشاكل في عمل الطالب (اختبار،
                    امتحان، أي شيء). افترض أنك أعددت اختبارًا يحتوي على 18
                    سؤالًا.
                  </p>
                  <p>
                    اكتب عدد الأسئلة التي أخطأ فيها الطالب. بدلاً من ذلك – إذا
                    كنت تفضل – يمكنك إدخال عدد النقاط المكتسبة. لنفترض أن طالبنا
                    النموذجي أخطأ في الإجابة عن ثلاثة أسئلة.
                  </p>
                  <p>
                    ها نحن ذا! تعرض أداة تقدير المعلم النسبة المئوية والدرجة
                    لهذا الامتحان. في مثالنا، حصل الطالب على 83.33% في الاختبار،
                    وهو ما يتوافق مع درجة B.
                  </p>
                  <p>
                    ستجد أدناه جدول المقياس الكامل للدرجات. لذا، للتحقق من درجة
                    الطلاب التالية، يمكنك كتابة عدد الأسئلة التي أخطأوا فيها –
                    أو ببساطة استخدم هذا الجدول الجميل.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeCalculator;
